// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.O6yO7BArVG0p4xvb {
  display: flex;
  background-color: #f3f5f7;
  margin-left: 315px;
  margin-top: 97px;
  min-height: calc(100vh - 97px);
}

.CRixB0A2V8tCnM8V {
  flex: 1;
  padding: 20px;
}

@media screen and (max-width: 1280px) {
  .O6yO7BArVG0p4xvb {
    margin-top: 65px;
    min-height: calc(100vh - 65px);
  }
}

@media screen and (max-width: 1104px) {
  .O6yO7BArVG0p4xvb {
    margin-left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Manager/ManagerPortal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,OAAO;EACP,aAAa;AACf;;AAEA;EACE;IACE,gBAAgB;IAChB,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".managerPortal {\r\n  display: flex;\r\n  background-color: #f3f5f7;\r\n  margin-left: 315px;\r\n  margin-top: 97px;\r\n  min-height: calc(100vh - 97px);\r\n}\r\n\r\n.routeContainer {\r\n  flex: 1;\r\n  padding: 20px;\r\n}\r\n\r\n@media screen and (max-width: 1280px) {\r\n  .managerPortal {\r\n    margin-top: 65px;\r\n    min-height: calc(100vh - 65px);\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1104px) {\r\n  .managerPortal {\r\n    margin-left: 0;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export var managerPortal = `O6yO7BArVG0p4xvb`;
export var routeContainer = `CRixB0A2V8tCnM8V`;
export default ___CSS_LOADER_EXPORT___;
